@if (!oerebServiceNichtVerfuegbar) {
  @if ((hasData | async) != false) {
    <div class="mt-3">
      <ng-content></ng-content>
    </div>
  } @else {
    <p>{{ "oereb.KeineInformationenVorhanden" | translate }}</p>
  }
} @else {
  <div class="mt-3">
    <cap-bsg-alert type="warning">
      {{ "oereb.nichtVerfuegbar" | translate }}
    </cap-bsg-alert>
  </div>
}
